import {
    initializeMentionAutocompletes,
} from './mention-autocomplete';

const initializeMessageAjax = () => {
    const composer =
        document.querySelector(
            '[data-message-composer]'
        );

    const messageList =
        document.querySelector(
            '[data-message-list]'
        );

    if (!composer || !messageList) {
        return;
    }

    const textarea =
        composer.querySelector(
            'textarea[name="body"]'
        );

    const submitButton =
        composer.querySelector(
            'button[type="submit"]'
        );

    const attachmentQueue =
        composer.querySelector(
            '[data-message-attachment-queue]'
        );

    const insertionPoint =
        messageList.querySelector(
            '[data-message-insertion-point]'
        );

    let latestMessageId = Number(
        messageList.dataset.latestMessageId ?? 0
    );
	
    if (
        !textarea
        || !submitButton
        || !attachmentQueue
        || !insertionPoint
    ) {
        return;
    }

    const originalButtonText =
        submitButton.textContent;

    let submitting = false;

    const setSubmitting = (
        isSubmitting
    ) => {
        submitting = isSubmitting;

        submitButton.disabled =
            isSubmitting;

        textarea.disabled =
            isSubmitting;

        submitButton.textContent =
            isSubmitting
                ? 'Sending...'
                : originalButtonText;

        submitButton.classList.toggle(
            'opacity-60',
            isSubmitting
        );

        submitButton.classList.toggle(
            'cursor-not-allowed',
            isSubmitting
        );
    };

    const removeError = () => {
        composer
            .querySelector(
                '[data-message-ajax-error]'
            )
            ?.remove();
    };

    const showError = (
        message
    ) => {
        removeError();

        const error =
            document.createElement('div');

        error.dataset.messageAjaxError = '';

        error.className =
            'mb-4 rounded-xl border '
            + 'border-red-400/30 '
            + 'bg-red-400/10 px-4 py-3 '
            + 'text-sm font-semibold '
            + 'text-red-200';

        error.setAttribute(
            'role',
            'alert'
        );

        error.textContent = message;

        composer.prepend(error);
    };

    const validationMessage = (
        data
    ) => {
        if (
            data?.errors
            && typeof data.errors === 'object'
        ) {
            const firstError =
                Object.values(data.errors)
                    .flat()
                    .find(
                        (error) =>
                            typeof error
                            === 'string'
                    );

            if (firstError) {
                return firstError;
            }
        }

        if (
            typeof data?.message === 'string'
            && data.message.trim() !== ''
        ) {
            return data.message;
        }

        return 'The message could not be sent.';
    };

    const createMessageElement = (
        html
    ) => {
        const template =
            document.createElement(
                'template'
            );

        template.innerHTML =
            html.trim();

        return template.content
            .firstElementChild;
    };

    const showEditError = (
        form,
        message
    ) => {
        form.querySelector(
            '[data-message-edit-error]'
        )?.remove();

        const error =
            document.createElement('div');

        error.dataset.messageEditError = '';

        error.className =
            'rounded-xl border '
            + 'border-red-400/30 '
            + 'bg-red-400/10 '
            + 'px-4 py-3 '
            + 'text-sm font-semibold '
            + 'text-red-200';

        error.setAttribute(
            'role',
            'alert'
        );

        error.textContent = message;

        form.prepend(error);
    };

    composer.addEventListener(
        'submit',
        async (event) => {
            event.preventDefault();

            if (submitting) {
                return;
            }

            removeError();

const formData =
    new FormData(composer);

setSubmitting(true);

try {
    const response =
        await fetch(
            composer.action,
            {
                method:
                    composer.method
                        .toUpperCase(),

                body:
                    formData,

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },
                        }
                    );

                const data =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        validationMessage(data)
                    );
                }

                if (
                    typeof data.html
                    !== 'string'
                ) {
                    throw new Error(
                        'The server returned an invalid message response.'
                    );
                }

                const messageElement =
                    createMessageElement(
                        data.html
                    );

                if (!messageElement) {
                    throw new Error(
                        'The new message could not be displayed.'
                    );
                }

                document
                    .querySelector(
                        '[data-empty-conversation]'
                    )
                    ?.remove();

                messageList.insertBefore(
                    messageElement,
                    insertionPoint
                );
				
				const newId = Number(
    messageElement.id.replace(
        'message-',
        ''
    )
);

if (newId > latestMessageId) {
    latestMessageId = newId;
}
    messageList.dataset.latestMessageId =
        latestMessageId;

                initializeMentionAutocompletes(
                    messageElement
                );

                composer.reset();

                if (
                    typeof attachmentQueue
                        .resetAttachmentQueue
                    === 'function'
                ) {
                    attachmentQueue
                        .resetAttachmentQueue();
                }

                if (
                    typeof composer
                        .clearReplyPreview
                    === 'function'
                ) {
                    composer
                        .clearReplyPreview();
                }

                messageElement
                    .scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });

                textarea.focus();
            } catch (error) {
                showError(
                    error instanceof Error
                        ? error.message
                        : 'The message could not be sent.'
                );
            } finally {
                setSubmitting(false);
            }
        }
    );
    messageList.addEventListener(
        'submit',
        async (event) => {
            const form = event.target;

            if (
                !(form instanceof HTMLFormElement)
                || !form.matches(
                    '[data-message-edit-form]'
                )
            ) {
                return;
            }

            event.preventDefault();

            if (
                form.dataset.submitting
                === 'true'
            ) {
                return;
            }

            const messageElement =
                form.closest(
                    '[id^="message-"]'
                );

            const submitButton =
                form.querySelector(
                    'button[type="submit"]'
                );

            const textarea =
                form.querySelector(
                    'textarea[name="body"]'
                );

            if (
                !messageElement
                || !submitButton
                || !textarea
            ) {
                return;
            }

            form.querySelector(
                '[data-message-edit-error]'
            )?.remove();

            const originalButtonText =
                submitButton.textContent;

            const formData =
                new FormData(form);

            form.dataset.submitting =
                'true';

            submitButton.disabled = true;
            textarea.readOnly = true;

            submitButton.textContent =
                'Saving...';

            submitButton.classList.add(
                'opacity-60',
                'cursor-not-allowed'
            );

            try {
                const response = await fetch(
                    form.action,
                    {
                        method: 'POST',

                        body:
                        formData,

                        credentials:
                            'same-origin',

                        headers: {
                            Accept:
                                'application/json',

                            'X-Requested-With':
                                'XMLHttpRequest',
                        },
                    }
                );

                const data =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        validationMessage(data)
                    );
                }

                if (
                    typeof data.html
                    !== 'string'
                ) {
                    throw new Error(
                        'The server returned an invalid message response.'
                    );
                }

                const updatedElement =
                    createMessageElement(
                        data.html
                    );

                if (!updatedElement) {
                    throw new Error(
                        'The edited message could not be displayed.'
                    );
                }

                messageElement.replaceWith(
                    updatedElement
                );

                initializeMentionAutocompletes(
                    updatedElement
                );
            } catch (error) {
                textarea.readOnly = false;
                submitButton.disabled = false;

                submitButton.textContent =
                    originalButtonText;

                submitButton.classList.remove(
                    'opacity-60',
                    'cursor-not-allowed'
                );

                delete form.dataset.submitting;

                showEditError(
                    form,
                    error instanceof Error
                        ? error.message
                        : 'The message could not be updated.'
                );
            }
        }
    );
    messageList.addEventListener(
        'submit',
        async (event) => {
            const form = event.target;

            if (
                !(form instanceof HTMLFormElement)
                || !form.matches(
                    '[data-message-delete-form]'
                )
            ) {
                return;
            }

            event.preventDefault();

            const messageElement =
                form.closest(
                    '[id^="message-"]'
                );

            if (!messageElement) {
                return;
            }

            const submitButton =
                form.querySelector(
                    'button[type="submit"]'
                );

            if (!submitButton) {
                return;
            }

            submitButton.disabled = true;

            try {
                const response =
                    await fetch(
                        form.action,
                        {
                            method: 'POST',

                            body:
                                new FormData(form),

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },
                        }
                    );

                const data =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        validationMessage(data)
                    );
                }

                if (
                    typeof data.html
                    !== 'string'
                ) {
                    throw new Error(
                        'The server returned an invalid message response.'
                    );
                }

                const updatedElement =
                    createMessageElement(
                        data.html
                    );

                if (!updatedElement) {
                    throw new Error(
                        'The deleted message could not be displayed.'
                    );
                }

                messageElement.replaceWith(
                    updatedElement
                );
                document.dispatchEvent(
                    new CustomEvent(
                        'festfriends:confirmation-complete'
                    )
                );
            } catch (error) {
                submitButton.disabled =
                    false;

                document.dispatchEvent(
                    new CustomEvent(
                        'festfriends:confirmation-complete'
                    )
                );
                
                alert(
                    error instanceof Error
                        ? error.message
                        : 'The message could not be deleted.'
                );
            }
        }
    );
};

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeMessageAjax
    );
} else {
    initializeMessageAjax();
}